import { render, staticRenderFns } from "./agenda_detail.vue?vue&type=template&id=480b645e&"
import script from "./agenda_detail.vue?vue&type=script&lang=js&"
export * from "./agenda_detail.vue?vue&type=script&lang=js&"
import style0 from "./agenda_detail.vue?vue&type=style&index=0&id=480b645e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports